import React, { ButtonHTMLAttributes } from "react";
import "./style.css";
import { ReactComponent as CloseIcon } from "../../../assets/svg/icons/close.svg";

type RCloseButtonProps = ButtonHTMLAttributes<HTMLButtonElement>;

export const RoundedCloseButton: React.FC<RCloseButtonProps> = ({
  onClick,
  ...rest
}) => {
  return (
    <button {...rest} className="close-button" onClick={onClick} type="button">
      <CloseIcon />
    </button>
  );
};
